module.exports = "pegasus_template/assets/themecapture1/large/51.png";